import { FC, Suspense } from 'react';
import { PreloadedQuery } from 'react-relay';
import { ProgressStudentsRoadmapByGradeQuery } from '../../../graphQLOperations/__generated__/ProgressStudentsRoadmapByGradeQuery.graphql';
import RoadmapsProgressByGradeTable from './RoadmapsProgressByGradeTable';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';

interface Props {
  roadmapQueryRef: PreloadedQuery<ProgressStudentsRoadmapByGradeQuery> | unknown;
}
const ProgressStudentRoadmapProgressTable: FC<Props> = ({ roadmapQueryRef }) => {
  return (
    <>
      {roadmapQueryRef ? (
        <Suspense fallback={<ThreeDotLoader dark />}>
          <RoadmapsProgressByGradeTable
            roadmapQueryRef={roadmapQueryRef as PreloadedQuery<ProgressStudentsRoadmapByGradeQuery>}
          />
        </Suspense>
      ) : (
        <></>
      )}
    </>
  );
};
export default ProgressStudentRoadmapProgressTable;
